import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MyListApi } from "../utils/restApi";
import { notification } from "../utils/utils";

export const fetchItems = createAsyncThunk('items2/fetchItems', async ({ userId, tag, name, sort, isPopular, page, perPage = 5 }) => {
    const data = await MyListApi.getItems(userId, tag, name, sort, isPopular, page, perPage);
    return data;
});

export const fetchPopularItems = createAsyncThunk('items2/fetchPopularItems', async ({ tag, page, perPage = 5}) => {
    const data = await MyListApi.getItems(null, tag, null, null, true, page, perPage);
    return data;
});

export const updateItemAction = createAsyncThunk('items2/updateItemAction', async ({ itemId, action }, { dispatch }) => {
    const data = await MyListApi.collectItem(itemId, action);
    dispatch(addActionToItem({ itemId: itemId, actionName: action }));
    return data;
});

export const fetchItem = createAsyncThunk('items2/fetchItem', async ({ itemId }) => {
    const data = await MyListApi.getItem(itemId);
    return data;
});

export const fetchPendingItems = createAsyncThunk('items2/fetchPendingItems', async ({ page, pageSize }) => {
    const data = await MyListApi.fetchPendingItems(page, pageSize);
    return data;
});

export const approveItem = createAsyncThunk('items2/approveItem', async (itemId) => {
    const data = await MyListApi.approveItem(itemId);
    return data;
});

const items2Slice = createSlice({
    name: 'items2',
    initialState: {
        tag: '',
        page: 0,
        items: [],
        count: 0,
        status: 'idle',
        error: null,
        popular: {
            items: [],
            status: 'idle',
            error: null,
        },
    },
    reducers: {
        resetPopularStatus: (state) => {
            state.popular.status = 'idle';
            state.popular.items = [];
            state.popular.count = 0;
            state.popular.error = null;
        },
        resetStatus: (state) => {
            state.status = 'idle';
            state.items = [];
            state.count = 0;
            state.error = null;
        },
        addActionToItem: (state, action) => {
            const { itemId, actionName } = action.payload;
            const item = state.items.find(i => i.id === itemId);
            if (item) {
                const actionStat = item.actionStats.find(as => as.action === actionName);
                if (actionStat) {
                    actionStat.count++;
                } else {
                    item.actionStats.push({ action: actionName, count: 1 });
                }
                if (!item.actions.includes(actionName)) {
                    item.actions.push(actionName);
                }
            }
        },
        addItemUpdateToItem: (state, action) => {
            const { itemId, itemUpdate } = action.payload;
            const item = state.items.find(i => i.id === itemId);
            if (item) {
                item.item_updates.push(itemUpdate);
            }
        },
        setTag: (state, action) => {
            state.tag = action.payload;
            state.items = [];
            state.count = 0;
            state.status = 'idle';
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchItems.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(fetchItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tag = action.meta.arg.tag;
                state.items = action.payload.items;
                state.count = action.payload.count;
                state.page = action.payload.page;
            })
            .addCase(fetchItems.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.error.message;
            })

        builder
            .addCase(fetchPopularItems.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(fetchPopularItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload.items;
                state.count = action.payload.count;
                state.page = action.payload.page;
            })
            .addCase(fetchPopularItems.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.error.message;
            });

        builder
            .addCase(updateItemAction.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(updateItemAction.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateItemAction.rejected, (state, action) => {
                state.status = 'error';
            });

        builder
            .addCase(fetchItem.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(fetchItem.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = [action.payload];
                state.count = 1;
                state.page = 0;
            })
            .addCase(fetchItem.rejected, (state, action) => {
                state.status = 'error';
            });

        builder
            .addCase(fetchPendingItems.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(fetchPendingItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload.items;
                state.count = action.payload.count;
                state.page = action.payload.page;
            })
            .addCase(fetchPendingItems.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error.message;
                notification(state.error, "error");
            });

        builder
            .addCase(approveItem.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(approveItem.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(approveItem.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error.message;
            });
    }
})

export const { resetStatus, addActionToItem, addItemUpdateToItem, setTag, resetPopularStatus } = items2Slice.actions;
export default items2Slice.reducer;